// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AccordionController from "./accordion_controller";
application.register("accordion", AccordionController);

import AdminSidebarController from "./admin_sidebar_controller";
application.register("admin-sidebar", AdminSidebarController);

import ApplicationFilterController from "./application_filter_controller";
application.register("application-filter", ApplicationFilterController);

import ApplicationSearchController from "./application_search_controller";
application.register("application-search", ApplicationSearchController);

import ApplicationViewToggleController from "./application_view_toggle_controller";
application.register(
  "application-view-toggle",
  ApplicationViewToggleController
);

import ApplicationWizardController from "./application_wizard_controller";
application.register("application-wizard", ApplicationWizardController);

import BadgeClickController from "./badge_click_controller";
application.register("badge-click", BadgeClickController);

import BadgeController from "./badge_controller";
application.register("badge", BadgeController);

import BadgeModalController from "./badge_modal_controller";
application.register("badge-modal", BadgeModalController);

import BadgeModalTriggerController from "./badge_modal_trigger_controller";
application.register("badge-modal-trigger", BadgeModalTriggerController);

import BadgePreviewController from "./badge_preview_controller";
application.register("badge-preview", BadgePreviewController);

import BadgeViewTrackerController from "./badge_view_tracker_controller";
application.register("badge-view-tracker", BadgeViewTrackerController);

import BookmarkButtonController from "./bookmark_button_controller";
application.register("bookmark-button", BookmarkButtonController);

import BulkOperationsController from "./bulk_operations_controller";
application.register("bulk-operations", BulkOperationsController);

import CandidateDetailsController from "./candidate_details_controller";
application.register("candidate-details", CandidateDetailsController);

import CandidateSelectionController from "./candidate_selection_controller";
application.register("candidate-selection", CandidateSelectionController);

import ChatController from "./chat_controller";
application.register("chat", ChatController);

import ChatRequestButtonController from "./chat_request_button_controller";
application.register("chat-request-button", ChatRequestButtonController);

import ChatRequestModalController from "./chat_request_modal_controller";
application.register("chat-request-modal", ChatRequestModalController);

import ConfettiController from "./confetti_controller";
application.register("confetti", ConfettiController);

import CoreCompetenciesController from "./core_competencies_controller";
application.register("core-competencies", CoreCompetenciesController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import FileUploadController from "./file_upload_controller";
application.register("file-upload", FileUploadController);

import FilterPanelController from "./filter_panel_controller";
application.register("filter-panel", FilterPanelController);

import ImagePreviewController from "./image_preview_controller";
application.register("image-preview", ImagePreviewController);

import FormBranchingController from "./form_branching_controller";
application.register("form-branching", FormBranchingController);

import FormResetController from "./form_reset_controller";
application.register("form-reset", FormResetController);

import FormWizardController from "./form_wizard_controller";
application.register("form-wizard", FormWizardController);

import ImpersonationController from "./impersonation_controller";
application.register("impersonation", ImpersonationController);

import JobEditFormController from "./job_edit_form_controller";
application.register("job-edit-form", JobEditFormController);

import JobSearchController from "./job_search_controller";
application.register("job-search", JobSearchController);

import JobSelectionController from "./job_selection_controller";
application.register("job-selection", JobSelectionController);

import JobStackController from "./job_stack_controller";
application.register("job-stack", JobStackController);

import KeyStatsController from "./key_stats_controller";
application.register("key-stats", KeyStatsController);

import MessageController from "./message_controller";
application.register("message", MessageController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import MultiStepFormController from "./multi_step_form_controller";
application.register("multi-step-form", MultiStepFormController);

import OnboardingFlowController from "./onboarding_flow_controller";
application.register("onboarding-flow", OnboardingFlowController);

import OnboardingPersistenceController from "./onboarding_persistence_controller";
application.register("onboarding-persistence", OnboardingPersistenceController);

import PriceSyncController from "./price_sync_controller";
application.register("price-sync", PriceSyncController);

import ProfileFormController from "./profile_form_controller";
application.register("profile-form", ProfileFormController);

import RevealController from "./reveal_controller";
application.register("reveal", RevealController);

import RoleSelectionController from "./role_selection_controller";
application.register("role-selection", RoleSelectionController);

import RoleSelectionSegmentedController from "./role_selection_segmented_controller";
application.register(
  "role-selection-segmented",
  RoleSelectionSegmentedController
);

import ScoutSidebarController from "./scout_sidebar_controller";
application.register("scout-sidebar", ScoutSidebarController);

import ScrollController from "./scroll_controller";
application.register("scroll", ScrollController);

import SegmentedController from "./segmented_controller";
application.register("segmented", SegmentedController);

import SettingsFormController from "./settings_form_controller";
application.register("settings-form", SettingsFormController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import SidebarStatsController from "./sidebar_stats_controller";
application.register("sidebar-stats", SidebarStatsController);

import StageUpdateController from "./stage_update_controller";
application.register("stage-update", StageUpdateController);

import StatusUpdateController from "./status_update_controller";
application.register("status-update", StatusUpdateController);

import SubscriptionController from "./subscription_controller";
application.register("subscription", SubscriptionController);

import TableOfContentsController from "./table_of_contents_controller";
application.register("table-of-contents", TableOfContentsController);

import TalentFilterTagsController from "./talent_filter_tags_controller";
application.register("talent-filter-tags", TalentFilterTagsController);

import TalentSearchController from "./talent_search_controller";
application.register("talent-search", TalentSearchController);

import TalentSidebarController from "./talent_sidebar_controller";
application.register("talent-sidebar", TalentSidebarController);

import TeamInvitesController from "./team_invites_controller";
application.register("team-invites", TeamInvitesController);

import TestController from "./test_controller";
application.register("test", TestController);

import TimezoneDetectorController from "./timezone_detector_controller";
application.register("timezone-detector", TimezoneDetectorController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import VerticalProgressController from "./vertical_progress_controller";
application.register("vertical-progress", VerticalProgressController);

import ViewToggleController from "./view_toggle_controller";
application.register("view-toggle", ViewToggleController);
